/* eslint-disable @angular-eslint/use-lifecycle-interface */
import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ClassScheduleService } from "app/services/class-schedule.service";
import { isEmpty } from "lodash";
import { take } from "rxjs/operators";

@Component({
  selector: "app-class-schedule",
  templateUrl: "./class-schedule.component.html",
  styleUrls: ["./class-schedule.component.scss"],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassScheduleComponent implements OnInit {
  @Input() selectedProgramId: string;
  @Input() feeByProgram: boolean = false;
  @Input() selectedSchedules: any[] = [];
  @Input() kidName: string;
  @Input() selectedKid: [];
  @Output() setClassScheduleListForProgramRegistration: EventEmitter<any[]> =
    new EventEmitter<any[]>();
  @Output() classScheduleListChanged: EventEmitter<any[]> = new EventEmitter<
    any[]
  >();
  isWaitingTrue: boolean;
  selectedClassSchedule: any;
  rows: any[];
  onFullyBooked: boolean;
  onWaitingList: boolean;
  waitingListMessage: string;
  selected = [];
  private _classScheduleList: any[] = [];

  constructor(private _classScheduleService: ClassScheduleService) {}

  ngOnInit(): void {
    this.waitinglistMessage();
    this.showClassOnWaitingLegend();
    this.showClassOnFullyBookedLegend();
  }

  @Input()
  set classScheduleList(value: any[]) {
    this._classScheduleList = value;
    if (
      this.feeByProgram &&
      this._classScheduleList &&
      this._classScheduleList.length > 0
    ) {
      this.selectAllClassSchedules();
    }
  }

  get classScheduleList(): any[] {
    return this._classScheduleList;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isWaitingTrue = false;
    if (!isEmpty(this.selectedProgramId)) {
      this._classScheduleService.getProgramId(this.selectedProgramId);
    }
    if (!isEmpty(this.kidName)) {
      this._classScheduleService.getKidName(this.kidName);
    }

    const classListChanged = !!changes.classScheduleList;
    const feeByProgramChanged = !!changes.feeByProgram;
    const hasClassSchedules = this.classScheduleList?.length > 0;

    if (
      this.feeByProgram &&
      hasClassSchedules &&
      (classListChanged || feeByProgramChanged)
    ) {
      this.selectAllClassSchedules();
      return;
    }

    if (!this.feeByProgram && classListChanged) {
      this.selected = [];
      this.setClassScheduleListForProgramRegistration.emit([]);
    }

    if (feeByProgramChanged && !this.feeByProgram) {
      this.selected = [];
      this.setClassScheduleListForProgramRegistration.emit([]);
    }
  }

  selectAllClassSchedules(): void {
    if (this.classScheduleList?.length) {
      const registeredSchedules =
        this._classScheduleService[
          "_programRegistrationService"
        ].fetchListRegistrationSchedules();
      const registeredScheduleIds = registeredSchedules
        .filter((reg) => reg.Kid_name__c === this.kidName)
        .map((reg) => reg.Class_Schedule__c);

      const availableSchedules = this.classScheduleList.filter(
        (schedule) =>
          schedule.Is_Active__c &&
          !registeredScheduleIds.includes(schedule.Id) &&
          (schedule.Available_Spaces__c > schedule.Booked_Count__c ||
            (schedule.Available_Spaces__c === schedule.Booked_Count__c &&
              schedule.Available_Waiting_Spaces__c >
                schedule.Booked_Waiting__c))
      );

      if (availableSchedules.length > 0) {
        this.selected = [...availableSchedules];
        this.setClassScheduleListForProgramRegistration.emit(
          availableSchedules
        );
      } else {
        this.selected = [];
        this.setClassScheduleListForProgramRegistration.emit([]);
      }
    } else {
      this.selected = [];
      this.setClassScheduleListForProgramRegistration.emit([]);
    }
  }

  showClassOnWaitingLegend(): void {
    this._classScheduleService.isClassScheduleOnWaitingList.subscribe(
      (isOnWaitingList: boolean) => {
        this.onWaitingList = isOnWaitingList;
      }
    );
  }

  showClassOnFullyBookedLegend(): void {
    this._classScheduleService.isClassScheduleOnFullyBooked.subscribe(
      (onFullyBooked: boolean) => {
        this.onFullyBooked = onFullyBooked;
      }
    );
  }

  waitinglistMessage(): any {
    this.waitingListMessage =
      this._classScheduleService.fetchWaitingListMessage();
  }
}
